import 'angular:locale/data:es';
import 'angular:locale/data:en';
import 'projects/webapp/src/polyfills';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
